import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { promoBannersStore } from "../stores/promoBanners";
import ProgressiveImage from "react-progressive-graceful-image";
import Poster from "../assets/poster.png";
import {
	promoBannersEditModalStore,
} from "../stores/promoBannersEditModal";
import { promoBannersAddModalStore } from "../stores/promoBannersAddModal";
import SpaceBetween from "@cloudscape-design/components/space-between";
/* ------- */



class TournamentsBanners extends React.Component {
	componentDidMount() {
		this.props.Interface.loadPromoBannerList();
	}


	render() {
		return (
			<>
				{this.props.promoBanners.loaded && this.props.promoBanners.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.promoBanners.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.promoBanners.error.code} | request timestamp: {this.props.promoBanners.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.promoBanners.loaded}
					columnDefinitions={[
						{ id: "name",  width: 300, header: "Name", cell: (item) =>
								<Button
									className={[this.props.styles["btn"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										setTimeout(() => {
											this.props.setPromoBannersEditModal({
												...this.props.promoBannersEditModal,
												show: true,
												image: item.image,
												nameType: this.props.promoBannersEditModal.currentOption.nameType.filter((element) => element.value === item.name.type)[0],
												name: item.name.text,
												oldName: item.name,
												descriptionType: this.props.promoBannersEditModal.currentOption.descriptionType.filter((element) => element.value === item.description.type)[0],
												gameID: item.gameID,
												minDeposit: item.minDeposit,
												limit: item.limit,
												wager: item.wager,
												description: item.description.text,
												descriptionPrefix: item.description.prefix,
												to: new Date(item.date*1000).toISOString(),
												from: new Date(item.date*1000).toISOString(),
											});
										}, 0);
									}}
									children={item.name.text}
								/>
						},
						{
							width: 70,
							id: "bigPoster",
							header: "image",
							cell: (item) => (
								<ProgressiveImage src={item.image} placeholder={Poster}>
									{(src) => <img style={{ width: "70px" }} src={src} alt={item.name} />}
								</ProgressiveImage>
							),
						},
						{ id: "type", header: "Name type", cell: (item) => item.name.type },
						{ id: "description_text", header: "Description Text", cell: (item) => item.description.text },
						{ id: "description_prefix", header: "Description prefix", cell: (item) => item.description.prefix ? item.description.prefix : "No" },
						{ id: "description_type", header: "Description type", cell: (item) => item.description.type },
						{ id: "wager", header: "Wager", cell: (item) => item.wager },
						{ id: "minDeposit", header: "Min deposit", cell: (item) => <>{new Intl.NumberFormat("ru-RU").format(item.minDeposit/100)} RUB.</>  },
						{ id: "gameID", header: "Game ID", cell: (item) => item.gameID ? item.gameID : "No" },
						{ id: "limit", header: "Limit", cell: (item) => item.limit ? item.limit : "No" },
						{ id: "date", header: "Date", cell: (item) => <>{new Date(item.date*1000).toLocaleDateString() + " " + new Date(item.date*1000).toLocaleTimeString()}</> },
					]}
					items={this.props.promoBanners.data}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
								/>
							}
						/>
					}
					header={<Box
						margin={{ bottom: "m" }}
						children={
							<Header
								children="Promo banners"
								counter={
									<>
										({this.props.promoBanners.data.length})
									</>
								}
								actions={
									<SpaceBetween direction="horizontal" size="l">
										<Button
											disabled={!this.props.promoBanners.loaded}
											className={[this.props.styles["players-search-button"], this.props.styles["btn"]].join(" ")}
											onClick={() => {
												setTimeout(() => {
													this.props.setPromoBannersAddModal({ ...this.props.promoBannersAddModal, show: true });
												}, 0);
											}}
											variant="primary"
											children="Add promo banner"
										/>
									</SpaceBetween>
								}
							/>
						}
					/>}
					empty="No promoBanners found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const promoBanners = useRecoilValue(promoBannersStore);
		const setPromoBanners = useSetRecoilState(promoBannersStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		const promoBannersEditModal = useRecoilValue(promoBannersEditModalStore);
		const setPromoBannersEditModal = useSetRecoilState(promoBannersEditModalStore);
		const promoBannersAddModal = useRecoilValue(promoBannersAddModalStore);
		const setPromoBannersAddModal = useSetRecoilState(promoBannersAddModalStore);

		return <Component {...props} promoBannersEditModal={promoBannersEditModal} setPromoBannersEditModal={setPromoBannersEditModal} promoBannersAddModal={promoBannersAddModal} setPromoBannersAddModal={setPromoBannersAddModal} promoBanners={promoBanners} setPromoBanners={setPromoBanners} config={config} setConfig={setConfig}  />;
	};
}

export default withRecoil(TournamentsBanners);
